import { useEffect, useRef, useMemo } from "react"
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js"
import { Pie } from "react-chartjs-2"

ChartJS.register(ArcElement, Tooltip, Legend)

export const StructuresAllocationPlot = ({ data, width = 500, height = 250, currency = "BRL" }) => {
  const getValue = (d) => (currency === "USD" ? d.value_usd : d.value_brl)

  const chartData = useMemo(() => {
    if (!data || !data.length) return null

    const filteredData = data.filter((d) => getValue(d) > 0)

    const colors = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"]

    return {
      labels: filteredData.map((d) => d.dim_bank_account.structure_path.join(" > ")),
      datasets: [
        {
          data: filteredData.map((d) => getValue(d)),
          backgroundColor: colors.slice(0, filteredData.length),
          borderColor: "#ffffff",
          borderWidth: 2,
        },
      ],
    }
  }, [data, currency])

  const options = {
    responsive: false,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "bottom", labels: { usePointStyle: true, font: { size: 10 } } },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || ""
            const value = context.parsed || 0
            const total = context.dataset.data.reduce((sum, val) => sum + val, 0)
            const percentage = ((value / total) * 100).toFixed(1)
            return `${label}: ${value.toLocaleString()} (${percentage}%)`
          },
        },
      },
    },
  }

  if (!chartData) return null

  return <Pie data={chartData} options={options} width={width} height={height} />
}
